import type { TextStyle } from "react-native";

/**
 * Maps every React Native `fontWeight` value (named + numeric) to the app's
 * custom font filename for the given family.
 *
 * Buckets:
 *   ultralight…regular, 100…400 → `-regular`
 *   medium / semibold / 500     → `-semibold`
 *   bold / heavier / 600…900    → `-bold`
 */
export type FontFamilyKey =
	| NonNullable<TextStyle["fontWeight"]>
	| "ultralight"
	| "thin"
	| "light"
	| "normal"
	| "regular"
	| "medium"
	| "semibold"
	| "heavy"
	| "bold"
	| "condensedBold"
	| "condensed"
	| "black"
	| "100"
	| "200"
	| "300"
	| "400"
	| "500"
	| "600"
	| "700"
	| "800"
	| "900";

export const getFontFamilyMapping = (
	appFont: string,
): Record<string, string> => ({
	ultralight: `${appFont}-regular`,
	thin: `${appFont}-regular`,
	light: `${appFont}-regular`,
	normal: `${appFont}-regular`,
	regular: `${appFont}-regular`,
	medium: `${appFont}-semibold`,
	semibold: `${appFont}-semibold`,
	heavy: `${appFont}-semibold`,
	bold: `${appFont}-bold`,
	condensedBold: `${appFont}-bold`,
	condensed: `${appFont}-bold`,
	black: `${appFont}-bold`,
	"100": `${appFont}-regular`,
	"200": `${appFont}-regular`,
	"300": `${appFont}-regular`,
	"400": `${appFont}-regular`,
	"500": `${appFont}-semibold`,
	"600": `${appFont}-bold`,
	"700": `${appFont}-bold`,
	"800": `${appFont}-bold`,
	"900": `${appFont}-bold`,
});
